import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container" }
const _hoisted_2 = { class: "ion-padding" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/store';
import logger from '@/logger';
import { translate } from '@/i18n';
import { showToast, isValidEmail } from '@/utils';
import Logo from '@/components/Logo.vue';
import {
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonInput,
  IonItem,
  IonPage
} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();

const emailAddress = ref("");

function validateCreateUserDetail(): string | null {
    if(!emailAddress.value) {
      return translate("Email address is required.");
    }
    if(emailAddress.value && !isValidEmail(emailAddress.value)) {
      return translate("Invalid email address.");
    }
    return null;
}

//  TODO: forgetPassword function is not functional yet, need to implement the API call
async function forgetPassword() {
  try {
    const validationErrors = validateCreateUserDetail();
    if(validationErrors) {
      const errorMessages = validationErrors
      logger.error(errorMessages);
      showToast(errorMessages);
      return;   
    }
    const payload = emailAddress.value;

    showToast(translate("Reset password link sent to your email."));
  } catch (err: any) {
    let errorMessage = "Failed to create user."
    if(err?.response?.data?.error?.message) {
      errorMessage = err.response.data.error.message;
    }
    logger.error("error", err);
    showToast(errorMessage);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonCard), null, {
              default: _withCtx(() => [
                _createElementVNode("form", {
                  class: "form-card",
                  onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (forgetPassword(_ctx.form)), ["enter"])),
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (forgetPassword(_ctx.form)), ["prevent"]))
                }, [
                  _createVNode(Logo),
                  _createVNode(_unref(IonCardHeader), { class: "ion-text-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Reset Password")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCardSubtitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Enter your email and we will send you a link to reset your password.")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        label: _unref(translate)('Email'),
                        "label-placement": "fixed",
                        modelValue: emailAddress.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailAddress).value = $event)),
                        type: "email"
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(IonButton), {
                      type: "submit",
                      color: "primary",
                      expand: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Send Link")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonButton), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/login'))),
                      fill: "clear",
                      expand: "block"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Back to Login")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})